/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { InjectionToken } from '@angular/core';
import {
  ActionRequiredItem,
  ActionRequiredType,
  UpcomingEventCard,
  UpcomingEventFilter,
  UpcomingEventsTag,
} from '../../models/event-card/event-card.model';
import { Page as Pagination } from '../../models/page';
import { ObservableResult } from '../../store';

export const SHARED_UPCOMING_DATA_SERVICE = new InjectionToken<SharedUpcomingDataService>('[Upcoming] SharedUpcomingDataService');

export interface ActionRequiredRequest {
  page: number;
  size: number;
  types?: ActionRequiredType[];
  afterDate?: Date;
  beforeDate?: Date;
  groups?: string[];
  managedByMe?: boolean;
  searchTerm?: string;
}

export interface SharedUpcomingDataService {
  getUpcomingEventsCards(
    page: number,
    size: number,
    frameworkId?: string,
    tagId?: string,
    languageCode?: string,
  ): ObservableResult<Pagination<UpcomingEventCard>>;

  getUpcomingEventsTags(page: number, size: number, term?: string): ObservableResult<Pagination<UpcomingEventsTag>>;

  hasUpcomingEvents(): ObservableResult<boolean>;

  getUpcomingEventsByFilter(page: number, size: number, filter: UpcomingEventFilter): ObservableResult<Pagination<UpcomingEventCard>>;

  getEventsEngagements(page: number, size: number, filter: UpcomingEventFilter): ObservableResult<Pagination<UpcomingEventCard>>;

  getActionRequiredItems(request: ActionRequiredRequest): ObservableResult<Pagination<ActionRequiredItem>>;
}
